export default {
  files: 'ADMIN_IMAGE_FILES'
};
